import { createSvgComponent } from "../../icon/createSvgComponent";
import TabMoreRight from "@core/icon/assets/tab-more-right.svg";
export default createSvgComponent(TabMoreRight);